<template>
  <div style="width: 21cm; height: 29cm" class="card">
    <div class="card-header">
      <strong>Print Preview</strong>
      <div class="card-header-actions">
        <CLink class="card-header-action btn-minimize">
          <c-button color="success" @click="confirmApprove = true" v-c-tooltip.hover.click="'Approve'" class="btn-action">
            <i class="cil-check"></i>
          </c-button>
          <c-button color="info" @click="doPrint" class="btn-action" v-c-tooltip.hover.click="'Cetak'">
            <i class="cil-print"></i>
          </c-button>
          <c-button color="danger" @click="doClose" class="btn-action" v-c-tooltip.hover.click="'Close'">
            <i class="cil-x"></i>
          </c-button>
        </CLink>
      </div>
    </div>
    <div id="dot-matrix-content">
      <router-view />
    </div>
    <CModal title="Approve Confirmation" size="sm" color="info" :show.sync="confirmApprove">
      Cetak nota ?
      <template #footer>
        <CButton @click="confirmApprove = false" color="danger">Tidak</CButton>
        <CButton @click="doApprove" color="success">Ya</CButton>
      </template>
    </CModal>
  </div>
</template>
<script>
import { HTTPAUTH } from "../../lib/httplib";
// import { jsPDF } from "jspdf";
// import html2canvas from "html2canvas";

export default {
  name: "Preview",
  data () {
    return {
      confirmApprove: false,
      query: {},
      params: {}
    };
  },
  created () {
    this.params = this.$route.params;
    this.query = this.$route.query;
  },
  methods: {
    async doPrint () {
      // const response = await fetch(require('@/assets/Courier_base64.txt'));
      // const customFontBase64 = await response.text();

      // const content = document.getElementById("dot-matrix-content");

      // html2canvas(content).then((canvas) => {
      //   const imgData = canvas.toDataURL("image/png");
      //   const pdf = new jsPDF();

      //   // Calculate the image height based on the canvas width and height
      //   const imgWidth = 210; // A4 width in mm
      //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

      //   // Add the image to the PDF
      //   pdf.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      //   window.open(pdf.output("bloburl"), "_blank");
      // })
      // const doc = new jsPDF({
      //   orientation: "P",
      //   unit: "mm",
      //   format: "a4"
      // });
      // // doc.addFileToVFS("Courier.ttf", customFontBase64);
      // // doc.addFont("Courier.ttf", "Courier", "normal");
      // // doc.setFont("Courier");
      // doc.html(document.getElementById("dot-matrix-content"), {
      //   callback: function (doc) {
      //     window.open(doc.output("bloburl"), "_blank");
      //   },
      //   x: 10,
      //   y: 10,
      //   width: 190,
      //   windowWidth: 1024,
      // })

      // console.log(this.query)
      window.open("#" + this.query.printurl + "/" + this.params.id, "_blank");

      // const content = document.getElementById("dot-matrix-content");
      // html2canvas(content).then((canvas) => {
      //   const imgData = canvas.toDataURL("image/png");
      //   const doc = new jsPDF({
      //     orientation: "P",
      //     unit: "mm",
      //     format: "a4"
      //   });

      //   // Calculate the image height based on the canvas width and height
      //   const imgWidth = 210; // A4 width in mm
      //   const imgHeight = (canvas.height * imgWidth) / canvas.width;

      //   // Add the image to the PDF
      //   doc.addImage(imgData, "PNG", 0, 0, imgWidth, imgHeight);
      //   window.open(doc.output("bloburl"), "_blank");
      // });
    },
    doClose () {
      this.$router.push({ path: this.query.rollback });
    },
    doApprove () {
      HTTPAUTH.put("/api/v1/sale/" + this.params.id)
        .then(res => {
          this.$toasted.success("Berhasil").goAway(3000);
          this.$router.push({ path: this.query.rollback });
        })
        .catch(eres => {
          this.$toasted.error(eres.response.data.user_message).goAway(3000);
        });
      this.confirmApprove = false;
    }
  }
};
</script>